import { useCallback } from "react"
import { batch, useSignal } from "@preact/signals-react"
import { postSubmit } from "@ui-seeker/utils"

import { WEBBACK_V2_API } from "@constants"
import { useToast, useUserApp } from "@hooks"
import { priceChangesReportFormIsOpen, priceChangesSubmittedFilters } from "../@signals"


export default function usePricingChangeForm(dataRow={}) {
	const { showToast } = useToast()
	const { userEmail, userCustomer } = useUserApp()
    
    const nameReport = useSignal('')
    const frequency = useSignal(null)
    const emailsReport = useSignal([userEmail])
    const conditions = useSignal(null)
	const priceUnderReference = useSignal('false')
	const percentagePriceUnder = useSignal(-1)

	const resetFormData = () => {
		nameReport.value = ''
		frequency.value = null
		emailsReport.value = [userEmail]
		conditions.value = null
		priceUnderReference.value = 'false'
		percentagePriceUnder.value = -1
	}

	const handleOpenForm = () => {
		priceChangesReportFormIsOpen.value = true
	}

	const handleSendToBack = () => {
		let apiUrl =`${WEBBACK_V2_API}/reports/create`

		if (frequency.value === 'now') {
			apiUrl = `${WEBBACK_V2_API}/reports/execute-now`
		}

		const conditionsFilters = {'priceChange': conditions.value}
		if (JSON.parse(priceUnderReference.value))
			conditionsFilters.priceUnderReference = percentagePriceUnder.value
		const payload = {
			nameReport: nameReport.value, frequency: frequency.value, conditions: conditionsFilters,
			emailsReport: emailsReport.value.join(","), reportType: 'priceChange',
			filters: {
				country: priceChangesSubmittedFilters.value.country, retailer: priceChangesSubmittedFilters.value.retailer,
				brand: priceChangesSubmittedFilters.value.brand, skuGroup: priceChangesSubmittedFilters.value.skuGroup,
				sku: priceChangesSubmittedFilters.value.sku, id_customer: userCustomer
			}
		}

        showToast.promise(postSubmit(apiUrl, payload), {
			error: 'Error: Please try again later.',
        	success: `Report successfully created.`,
		})
    }
	
	return {
		handleOpenForm,
        handleSendToBack,
		resetFormData,
        nameReport: nameReport,
        frequency: frequency,
        emailsReport: emailsReport,
        conditions: conditions,
		priceUnderReference: priceUnderReference,
		percentagePriceUnder: percentagePriceUnder
	}
}